import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useVenuedWastes, VenuedBundle, venuedBundleTqo, VenuedWaste} from "../venue/overview.tsx";
import {useMemo} from "react";
import {useQueries, useQueryClient} from "@tanstack/react-query";
import {BundleStub} from "../rpc/webrpc-client.gen.ts";
import {mergeUseQueriesWithInfill} from "../tq/mergeUseQueriesWithInfill.tsx";
import {cleanse, NADA} from "../util/arutil.tsx";
import {usePreferences} from "../agent/usePreferences.ts";
import {InspectionStageOrSurcharge} from "../inspect/stages.tsx";
import {TieredColor} from "../util/defaultPrefs.tsx";
import {useMothership} from "../tq/tqx.tsx";

// export function useInspectorPreferences(): InfallibleUseResult<AgentPreferences> {
//     const tqrv = usePreferences();
//     if (tqrv.isPending) {
//         return pendingUseResult;
//     }
//     const rv = {...defaultInspectorPrefs, ...tqrv.data};
//     return successUseResult(rv);
// }

export function useInspectorWastes({venueId}: { venueId: string }): InfallibleUseResult<VenuedWaste[]> {
    const vxwsTqrv = useVenuedWastes({venueId});
    const prefsTqrv = usePreferences();

    const rv = useMemo(() => {
        if (!vxwsTqrv.isSuccess) {
            return pendingUseResult;
        } else {
            const inspectionStageColorMap = prefsTqrv.data?.inspectionTierColors
                ? new Map<InspectionStageOrSurcharge, TieredColor<InspectionStageOrSurcharge>>(prefsTqrv.data.inspectionTierColors.map(rec => ([rec.tier, rec])))
                : undefined;

            const wanted = vxwsTqrv.data.filter(maybe =>
                (maybe.status?.inspectionStage && inspectionStageColorMap?.has(maybe.status.inspectionStage)));
            return successUseResult(wanted);
        }
    }, [prefsTqrv.data?.inspectionTierColors, vxwsTqrv.data, vxwsTqrv.isSuccess]);

    return rv;
}

export function useInspectorBundles({venueId}: { venueId: string }): InfallibleUseResult<VenuedBundle[]> {
    const tqc = useQueryClient();
    const mama = useMothership();
    const vxwsTqrv = useInspectorWastes({venueId});
    const wantedBundles = useMemo<BundleStub[] | undefined>(() => {
        if (vxwsTqrv.isSuccess) {
            const ubs = new Map<string, BundleStub>();
            for (const vxw of vxwsTqrv.data) {
                if (vxw.lastBundle) {
                    ubs.set(vxw.lastBundle.id, vxw.lastBundle);
                }
            }
            return Array.from(ubs.values());
        } else {
            return undefined;
        }
    }, [vxwsTqrv.data, vxwsTqrv.isSuccess]);
    const rv = useQueries(wantedBundles
        ? {
            queries: wantedBundles.map(stub => venuedBundleTqo({tqc, mama, args: {bundleId: stub.id}})),
            combine: mergeUseQueriesWithInfill
        }
        : {queries: NADA});
    return vxwsTqrv.isSuccess ? successUseResult(cleanse(rv.data)) : pendingUseResult;
}

